enum MapValues {
  ROUTE = 0, // and value > 0: visited algorithm
  WALL = -1,
}
export default MapValues;
